<template>
  <main class="market">
    <!-- <NavegationMenu /> -->
    <div class="mkcontainer">
      <h1 id="pTop">Working on this!.</h1>
      <h2>Here I'll show you what you can get from me (software or services).</h2>
    </div>

  </main>
</template>

<script>

export default {
  name: "Market",
  title: "Nethanzêl's Showroom",
  components: {
  },
  methods: {
  }

};
</script>

<style scoped lang="scss">
.market {
  display: flex;
  flex-direction: column;
  cursor: default;
  max-width: 1366px;
  margin: 0 auto 0 auto;
  padding-top: 60px;
}

.mkcontainer {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h1 {
  font-size: 75px;
  letter-spacing: 3px;
  cursor: default;
  transition: .4s;
}

h2 {
  font-size: 35px;
  letter-spacing: 2px;
  cursor: default;
  transition: .4s;
}

@media (prefers-color-scheme: dark) {
  h2, h1 {
    color: #fff;
  }
}

@media (prefers-color-scheme: light) {
  h2, h1 {
    color: #000;
  }
}

@media screen and (max-width: 660px) {
  h1 {
    font-size: 65px;
    letter-spacing: 3px;
  }

  h2 {
    font-size: 30px;
    letter-spacing: 2px;
  }
}

@media screen and (max-width: 570px) {
  h1 {
    font-size: 55px;
    letter-spacing: 3px;
  }

  h2 {
    font-size: 25px;
    letter-spacing: 2px;
  }
}

@media screen and (max-width: 490px) {
  h1 {
    font-size: 45px;
    letter-spacing: 3px;
  }

  h2 {
    font-size: 20px;
    letter-spacing: 2px;
  }
}
</style>
